module.exports = __webpack_public_path__ + "media/src/public/img/payment/phone-d20b4aa23b447f0b58fa58be2f5bb357.svg";